export const HEALTH_CHECK_TIMEOUT_MS = 5000
export const HEALTH_POLL_INTERVAL_MS = 5000

const HEALTH_ENDPOINT = "/health"

export async function checkBackendHealth(timeoutMs = HEALTH_CHECK_TIMEOUT_MS): Promise<boolean> {
    const controller = new AbortController()
    const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs)

    try {
        const response = await fetch(HEALTH_ENDPOINT, {
            signal: controller.signal,
        })

        if (!response.ok) {
            return false
        }

        const data = await response.json()
        return data?.status === "ok"
    } catch {
        return false
    } finally {
        window.clearTimeout(timeoutId)
    }
}
